import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupSubstract: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBooleanGroupSubstract"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2V8H2V22H16V16H22V2H8ZM20.5 14.5V3.5H9.5V14.5H20.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupSubstract;
